import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { delay, map, tap } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { isFunction } from 'src/app/shared/utilities/types.utils';
import { removeToastAction, showToastAction } from './toast.actions';
import { selectToasts } from './toast.selectors';
import { Toast, ToastState } from './toast.state';

@Injectable({
	providedIn: 'root',
})
export class ToastEffects {
	/**
	 * Handles toast lifespan
	 */
	showToast$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(showToastAction),
			delay(4000),
			map((action) => {
				const { onClose } = action;
				if (isFunction(onClose)) {
					onClose(action);
				}
				return removeToastAction();
			})
		);
	});

	/**
	 * Our effects constructor
	 * @param actions$ The action stream
	 */
	constructor(private actions$: Actions) {}
}
